import { combineReducers } from 'redux';
import { dlUnitLiReducer } from './dlUnitLiReducer';
import { dlUnitReducer } from './dlUnitReducer';
import { dlGroupReducer } from './dlGroupReducer';
import { dlGroupLiReducer } from './dlGroupLiReducer';
import { photoSerLiReducer } from './photoSerLiReducer';
import { photoSerReducer } from './photoSerReducer';
import { userLiReducer } from './userLiReducer';
import { userReducer } from './userReducer';
import { authReducer } from './authReducer';

export const rootReducer = combineReducers({
    dlUnitLi: dlUnitLiReducer, 
    dlUnit: dlUnitReducer,
    dlGroupLi: dlGroupLiReducer, 
    dlGroup: dlGroupReducer,
    phSerLi: photoSerLiReducer,
    phSer: photoSerReducer,    
    userLi: userLiReducer,
    user: userReducer,    
    auth: authReducer,
});

